import { BEAMER_CHANNEL_ID } from 'gcs-common/constants/channelConstants';
import { CHANNEL_FILTER_TYPES, CHANNEL_TYPE } from '../../../helper/channelTypeHelper';
import { getChannel, getPrimaryHouseForChannel } from '../../channel/channelSelectors';
import setChannelMessagesConsumed from '../../channel/channelThunks/setChannelMessagesConsumed';
import { setSelectedChannelTypeFilter } from '../../channelList/channelListSlice';
import { getIsAgent } from '../../currentUser/currentUserSelectors';
import { getSelectedHouseId } from '../../houses/housesSelectors';
import { selectedHouseIdChanged } from '../../houses/housesSlice';
import { latestMessageIsRead } from '../../messages/messageSelector';
import fetchMessages from '../../messages/messagesThunks/fetchMessages';
import { channelUpdated, preSelectChannelId, selectedChannelIdChanged } from '../channelsSlice';

const changeSelectedChannelId =
  ({ selectedChannelId }) =>
  async (dispatch, getState) => {
    const channel = getChannel(selectedChannelId)(getState());
    const selectedHouseId = getSelectedHouseId(getState());
    const channelHouseId = getPrimaryHouseForChannel(selectedChannelId)(getState());

    const isAgent = getIsAgent(getState());

    if (selectedChannelId === BEAMER_CHANNEL_ID) {
      dispatch(selectedChannelIdChanged({ selectedChannelId }));
      dispatch(setSelectedChannelTypeFilter({ selectedChannelTypeFilter: CHANNEL_FILTER_TYPES.TEAM_CHATS }));
      dispatch(
        channelUpdated({
          channel: {
            id: BEAMER_CHANNEL_ID,
            unreadCount: 0,
          },
        }),
      );
      return;
    }

    if (isAgent) {
      const selectedChannelTypeFilter =
        channel?.channelType === CHANNEL_TYPE.SALES_SPACE
          ? CHANNEL_FILTER_TYPES.TEAM_CHATS
          : CHANNEL_FILTER_TYPES.DIRECT_CHATS;
      dispatch(setSelectedChannelTypeFilter({ selectedChannelTypeFilter }));
    }

    if (!isAgent && channelHouseId && selectedHouseId !== channelHouseId) {
      dispatch(selectedHouseIdChanged({ selectedHouseId: channelHouseId }));
    }

    dispatch(
      fetchMessages({
        channelId: selectedChannelId,
        singlePage: true,
      }),
    );

    if (channel) {
      dispatch(selectedChannelIdChanged({ selectedChannelId }));

      const lastestIsRead = latestMessageIsRead(selectedChannelId)(getState());

      if (!lastestIsRead && !isAgent) {
        dispatch(setChannelMessagesConsumed({ channelId: selectedChannelId }));
      }
    } else {
      // wait until the channel was joined
      dispatch(preSelectChannelId({ preSelectedChannelId: selectedChannelId }));
    }
  };

export default changeSelectedChannelId;
